import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavbarText from '../components/NavbarText';
import Request from '../components/stop-request/Request';
import RequestList from '../components/stop-request/RequestList';
import RequestReply from '../components/stop-request/RequestReply';
import axios from "axios";
import * as securityHelper from "../helper/SecurityHelper";
import Snackbar from '../components/Snackbar';

interface IStopRequest {
  rCmpny: string;
  rDate: string;
  result: boolean;
  exbtPlc: string;
}

export default function StopRequest() {
  const navigate = useNavigate();
  const location = useLocation();
  const [request, setRequest] = useState(location.state.isRequest);
  const [stopRequestList, setStopRequestList] = useState<IStopRequest[]>();
  const [replyData, setReplyData] = useState<IStopRequest>();
  const [requestReply, setRequestReply] = useState(false);
  const [statusTab, setStatusTab] = useState('전체');
  const [cmpnyGbTab, setCmpnyGbTab] = useState('전체');
  const user = securityHelper.getLoginUser();
  const [snackbarTxt, setSnackbarTxt] = useState('');
  useEffect(() => { setTimeout(() => setSnackbarTxt(''), 2000) }, [snackbarTxt]);

  useEffect(() => {
    let prcsStatCd = '';
    if (statusTab === '전체') {
      prcsStatCd = '';
    } else if (statusTab === '중지요청') {
      prcsStatCd = '001';
    } else if (statusTab === '작업중지') {
      prcsStatCd = '002';
    } else if (statusTab === '작업재개') {
      prcsStatCd = '003';
    }

    let cmpnyGbCd = '';
    if (cmpnyGbTab === '전체') {
      cmpnyGbCd = '';
    } else if (cmpnyGbTab === '코엑스') {
      cmpnyGbCd = '003';
    } else if (cmpnyGbTab === '주최사') {
      cmpnyGbCd = '001'
    } else if (cmpnyGbTab === '협력업체') {
      cmpnyGbCd = '002'
    }

    fn_retrieveWrkStopRqstDataList(prcsStatCd, cmpnyGbCd);
  }, [request, requestReply, statusTab, cmpnyGbTab])

  const fn_retrieveWrkStopRqstDataList = async (prcsStatCd: string, cmpnyGbCd: string) => {
    const rtrnData = await axios.post('admin/api/wrkStopRqst/retrieveWrkStopRqstDataList', { rgstrSeq: user.seq, prcsStatCd: prcsStatCd, auth: user.auth, cmpnySeq: user.companySeq, cmpnyGbCd: cmpnyGbCd })

    setStopRequestList(rtrnData.data);
  }

  const backEvent = () => {
    if (!requestReply && !request) { navigate(-1) }
    else { setRequestReply(false); setRequest(false) };
  }

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      {snackbarTxt !== '' ? <Snackbar>{snackbarTxt}</Snackbar> : null}
      <NavbarText backEvent={backEvent}>작업중지요청</NavbarText>
      {!request && !requestReply &&
        <div className='h-105 md:h-[262px] flex flex-col items-center pt-10 md:pt-[25px]'>
          <div className='w-[265px] sm:w-[318px] md:w-[750px] h-30 md:h-[75px] flex items-center justify-between'>
            <StatusBtn1 statusTab={statusTab} setStatusTab={setStatusTab}>전체</StatusBtn1>
            <StatusBtn1 statusTab={statusTab} setStatusTab={setStatusTab}>작업재개</StatusBtn1>
            <StatusBtn1 statusTab={statusTab} setStatusTab={setStatusTab}>작업중지</StatusBtn1>
          </div>
          <div className='w-[265px] sm:w-[318px] md:w-[750px] h-30 md:h-[75px] flex items-center justify-between mt-15 md:mt-[37px]'>
            <StatusBtn2 statusTab={cmpnyGbTab} setStatusTab={setCmpnyGbTab}>전체</StatusBtn2>
            <StatusBtn2 statusTab={cmpnyGbTab} setStatusTab={setCmpnyGbTab}>코엑스</StatusBtn2>
            <StatusBtn2 statusTab={cmpnyGbTab} setStatusTab={setCmpnyGbTab}>주최사</StatusBtn2>
            <StatusBtn2 statusTab={cmpnyGbTab} setStatusTab={setCmpnyGbTab}>협력업체</StatusBtn2>
          </div>
        </div>}
      {requestReply ? <RequestReply replyData={replyData} setRequestReply={setRequestReply} setSnackbarTxt={setSnackbarTxt} />
        : request ? <Request setRequest={setRequest} setSnackbarTxt={setSnackbarTxt} />
          : <RequestList setRequest={setRequest} stopRequestList={stopRequestList} setRequestReply={setRequestReply} setReplyData={setReplyData} />}
    </div>
  );
}

const StatusBtn1 = ({ children, statusTab, setStatusTab }: any) => {
  const left = 'rounded-l-[5px] md:rounded-l-[12px]';
  const right = 'rounded-r-[5px] md:rounded-r-[12px]';

  return <button onClick={() => setStatusTab(children)}
    className={children === '전체' ?
      statusTab === '전체' ? `border ${left} border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
        : `border ${left} border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
      : children === '작업중지' ?
        statusTab === '작업중지' ? `border ${right} border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
          : `border ${right} border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
        : children === '중지요청' ?
          statusTab === '중지요청' ? `border border-l-0 border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
            : `border border-l-0 border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
          : children === statusTab ? `border border-r-0 border-l-0 border-[#2F2F35] bg-[#2F2F35] text-white text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`
            : `border border-r-0 border-l-0 border-[#2F2F35] bg-transparent text-[#464649] text-14 md:text-35 w-125 sm:w-159 md:w-[397px] h-36 md:h-[90px] font-preLight`}>{children}</button>
};

const StatusBtn2 = ({ children, statusTab, setStatusTab }: any) => {
  const user = securityHelper.getLoginUser();
  return <button onClick={() => setStatusTab(children)}
    className={statusTab === children
      ? user.auth === 'SRV' || user.auth === 'WOK'
        ? `w-63 sm:w-73 md:w-[182px] h-32 md:h-[80px] rounded-full bg-transparent border border-point text-point text-12 sm:text-14 md:text-35 font-preLight`
        : `w-70 sm:w-95 md:w-[237px] h-32 md:h-[80px] rounded-full bg-transparent border border-point text-point text-12 sm:text-14 md:text-35 font-preLight mx-5 md:mx-[12px]`
      : user.auth === 'SRV' || user.auth === 'WOK'
        ? `w-63 sm:w-73 md:w-[182px] h-32 md:h-[80px] rounded-full bg-transparent border border-white text-12 sm:text-14 md:text-35 font-preLight`
        : `w-70 sm:w-95 md:w-[237px] h-32 md:h-[80px] rounded-full bg-transparent border border-white text-12 sm:text-14 md:text-35 font-preLight mx-5 md:mx-[12px]`}>{children}</button>;
};

